import { useQuery } from '@tanstack/react-query';
import { fetchReseauxSociaux } from '../services/api';
import LogoReseau from './LogoReseau';

/**
 * Les réseaux du comité, en bas de la page d'accueil.
 *
 * La liste est tenue dans les paramètres : le bloc suit ce que le président y
 * a mis, sans déploiement. Il disparaît quand rien n'est renseigné — un
 * « Suivez-nous » sans lien ferait moins bonne impression qu'un silence.
 */
export default function SuivezNous() {
  const { data } = useQuery({
    queryKey: ['reseaux-sociaux'],
    queryFn: fetchReseauxSociaux,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });

  const reseaux: { reseau: string; url: string; label: string }[] = data?.reseaux ?? [];

  if (reseaux.length === 0) return null;

  return (
    <section className="card lg:p-6">
      <h2 className="text-lg lg:text-xl font-semibold text-gray-900 dark:text-gray-100">
        Suivez-nous
      </h2>
      <p className="text-sm lg:text-base text-gray-600 dark:text-gray-400 mt-1">
        Retrouvez toutes nos actualités sur les réseaux.
      </p>

      <div className="mt-4 flex flex-wrap gap-3">
        {reseaux.map((r) => (
          <a
            key={r.reseau}
            href={r.url}
            target="_blank"
            rel="noopener noreferrer"
            title={r.label}
            aria-label={r.label}
            className="w-12 h-12 rounded-2xl border border-gray-100 dark:border-gray-800 bg-white dark:bg-gray-800 flex items-center justify-center hover:shadow-md hover:-translate-y-0.5 transition"
          >
            <LogoReseau reseau={r.reseau} taille={26} />
          </a>
        ))}
      </div>
    </section>
  );
}
